import { createContext } from 'react';

export type FormValidatorContext = {
  wasValidated: boolean;
  error?: any;
}

export const FormContext = createContext<FormValidatorContext>(undefined);
